import React from "react";
import { DateTime } from "luxon";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";
import { useRootAppStore } from "@hooks";

export default observer(function LoginHistory() {
	const { t } = useTranslation();

	const rootStore = useRootAppStore();

	if (rootStore.userAuthStore.loginHistory == null) {
		return <div>{t("HEADER.FIRST_LOGIN")}</div>;
	}

	return (
		<>
			<div>
				<span className="u-mar--right--nano">
					{" "}
					{t("HEADER.LAST_LOGIN")}{" "}
				</span>
				{DateTime.fromISO(
					rootStore.userAuthStore.loginHistory.lastLogin
				).toFormat("dd.MM.yyyy HH:mm:ss")}
			</div>
			<div>
				<span className="u-mar--right--nano">
					{" "}
					{t("HEADER.LOGGED_IN_FROM")}{" "}
				</span>{" "}
				{DateTime.fromISO(
					rootStore.userAuthStore.loginHistory.currentLogin
				).toFormat("dd.MM.yyyy HH:mm:ss")}
			</div>
		</>
	);
});
